export enum Assets {
    MorayEast = "MorayEast",
    MorayWest = "MorayWest",
    FirstHydro = "FHC",
    Retail = "Retail",
    Res = "Res",
  }